var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("form", { attrs: { "data-vv-scope": "user" } }, [
        _c("div", { staticClass: "row mt-5" }, [
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c("vs-input", {
                staticClass: "w-100 cursor-default",
                attrs: {
                  autocomplete: "off",
                  label: "Rut",
                  maxlength: "12",
                  name: "iut",
                  readonly: ""
                },
                model: {
                  value: _vm.cuUserData.iut,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "iut", $$v)
                  },
                  expression: "cuUserData.iut"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c("vs-input", {
                staticClass: "w-100 cursor-default",
                attrs: {
                  autocomplete: "off",
                  label: "Nombres",
                  maxlength: "250",
                  name: "name",
                  readonly: ""
                },
                model: {
                  value: _vm.cuUserData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "name", $$v)
                  },
                  expression: "cuUserData.name"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c("vs-input", {
                staticClass: "w-100 cursor-default",
                attrs: {
                  autocomplete: "off",
                  label: "Apellido Paterno",
                  maxlength: "200",
                  name: "lastName",
                  readonly: ""
                },
                model: {
                  value: _vm.cuUserData.lastName,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "lastName", $$v)
                  },
                  expression: "cuUserData.lastName"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c("vs-input", {
                staticClass: "w-100 cursor-default",
                attrs: {
                  autocomplete: "off",
                  label: "Apellido Materno",
                  maxlength: "250",
                  name: "mothersLastName",
                  readonly: ""
                },
                model: {
                  value: _vm.cuUserData.mothersLastName,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "mothersLastName", $$v)
                  },
                  expression: "cuUserData.mothersLastName"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Dirección",
                  maxlength: "250",
                  name: "address",
                  danger: _vm.errors.has("user.address"),
                  "danger-text": _vm.errors.first("user.address")
                },
                model: {
                  value: _vm.cuUserData.address,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "address", $$v)
                  },
                  expression: "cuUserData.address"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Número Documento / Número de serie",
                  maxlength: "200",
                  name: "iutNumber",
                  danger: _vm.errors.has("user.iutNumber"),
                  "danger-text": _vm.errors.first("user.iutNumber")
                },
                model: {
                  value: _vm.cuUserData.iutNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "iutNumber", $$v)
                  },
                  expression: "cuUserData.iutNumber"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Correo Personal",
                  maxlength: "250",
                  name: "email",
                  danger: _vm.errors.has("user.email"),
                  "danger-text": _vm.errors.first("user.email")
                },
                model: {
                  value: _vm.cuUserData.email,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "email", $$v)
                  },
                  expression: "cuUserData.email"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|numeric",
                    expression: "'required|numeric'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Teléfono fijo",
                  maxlength: "20",
                  name: "landline",
                  danger: _vm.errors.has("user.landline"),
                  "danger-text": _vm.errors.first("user.landline")
                },
                model: {
                  value: _vm.cuUserData.landline,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "landline", $$v)
                  },
                  expression: "cuUserData.landline"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|numeric",
                    expression: "'required|numeric'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Teléfono móvil",
                  maxlength: "25",
                  name: "phone",
                  danger: _vm.errors.has("user.phone"),
                  "danger-text": _vm.errors.first("user.phone")
                },
                model: {
                  value: _vm.cuUserData.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "phone", $$v)
                  },
                  expression: "cuUserData.phone"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c(
                "vs-select",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-100 con-select autocompletex",
                  attrs: {
                    autocomplete: "off",
                    placeholder: "Seleccione estado civil",
                    label: "Estado Civil",
                    name: "civilStatus",
                    danger: _vm.errors.has("user.civilStatus"),
                    "danger-text": _vm.errors.first("user.civilStatus")
                  },
                  model: {
                    value: _vm.cuUserData.civilStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.cuUserData, "civilStatus", $$v)
                    },
                    expression: "cuUserData.civilStatus"
                  }
                },
                [
                  _c("vs-select-item", {
                    attrs: { value: "Soltero", text: "Soltero" }
                  }),
                  _c("vs-select-item", {
                    attrs: { value: "Casado", text: "Casado" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|date_format:yyyy-mm-dd",
                    expression: "'required|date_format:yyyy-mm-dd'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Fecha de nacimiento",
                  placeholder:
                    "Ejemplo: 1995-12-20 (significa 20 de diciembre de 1995)",
                  maxlength: "10",
                  name: "birthday",
                  danger: _vm.errors.has("user.birthday"),
                  "danger-text": _vm.errors.first("user.birthday")
                },
                model: {
                  value: _vm.cuUserData.birthday,
                  callback: function($$v) {
                    _vm.$set(_vm.cuUserData, "birthday", $$v)
                  },
                  expression: "cuUserData.birthday"
                }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "text-right mt-4" },
          [
            !_vm.getCertificate
              ? _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: { click: _vm.getSecurityQuestions }
                  },
                  [_vm._v(" Solicitar ")]
                )
              : _vm._e(),
            _vm.getCertificate
              ? _c(
                  "div",
                  { staticClass: "text-right mt-4" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "success" },
                        on: { click: _vm.getCertificateRequest }
                      },
                      [_vm._v(" Solicitar certificado ")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          ref: "questions",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Preguntas de seguridad"
          }
        },
        [
          _c("SecurityQuestions", {
            attrs: {
              securityQuestions: _vm.securityQuestions,
              getCertificate: _vm.getCertificate,
              loading: _vm.loading,
              cuUserData: _vm.cuUserData
            },
            on: {
              loading: function($event) {
                _vm.loading = $event
              },
              closeModal: _vm.closeModal
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }